export const config = (onView, withFilter) => [
  {
    name: "Numéro contrat",
    selector: (row) => row.contract_number,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Montant financement",
    selector: (row) => row.final_amount,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.final_amount === 0 ? "" : row.final_amount),
  },
  {
    name: "Etat du contrat",
    selector: (row) => row.status,
    sortable: true,
    filterable: withFilter,
    cell: (row) =>
      row.status === "MIS EN FORCE" ? (
        <div className="chip-status success">{row.status}</div>
      ) : (
        row.status
      ),
  },
  {
    name: "Encours",
    selector: (row) => row.ongoing,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Matériel",
    selector: (row) => row.equipement,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Date mise en force",
    selector: (row) => row.datemf,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Date fin du contrat",
    selector: (row) => row.end_date,
    sortable: true,
    filterable: withFilter,
    minWidth: "150px !important",
  },

  //   {
  //     name: "Actions",
  //     selector: (row) => row.id,
  //     cell: (row) => (
  //       <Button
  //         view="clear"
  //         variant="dark"
  //         isIconButton
  //         title="View"
  //         onClick={() => onView(row.id)}
  //       >
  //         <RiEyeLine />
  //       </Button>
  //     ),
  //   },
];
